interface Props {
  children?: React.ReactNode;
}

export const PageContainer: React.FC<Props> = ({ children }) => {
  return <div className="pt-6 px-4 space-y-4 h-full ">{children}</div>;
};
